import * as $ from 'jquery';
import 'datatables';

export default (function () {
  $('#dataTable').DataTable();
}())



// WEBPACK FOOTER //
// ./resources/assets/js/datatable/index.js